<template>
  <div class="architectPage">
    <template v-if="from!='introDetail'">
    <Header />
    <Box1 />
    </template>
    <Box2 />
    <Box3 />
    <Box4 />
    <Box5 />
    <Box6new />
    <Box6 />
    <Box7 />
    <Box8 />
    <Box9new />
    <Box9 />
    <Box10 />
    <Box11 />
    <Box12 />
    <Box13 />
    <Box14 />
    <Box15 />
    <Box16 />
    <pageRightFloat pageName="狂野架构师-职场进阶课"/>
    <Footer />
   
  </div>
</template>

<script>
import Box1 from "./Box1.vue";
import Box2 from "./Box2.vue";
import Box3 from "./Box3.vue";
import Box4 from "./Box4.vue";
import Box5 from "./Box5.vue";
import Box6new from "./Box6new.vue";
import Box6 from "./Box6.vue";
import Box7 from "./Box7.vue";
import Box8 from "./Box8.vue";
import Box9new from "./Box9new.vue";
import Box9 from "./Box9.vue";
import Box10 from "./Box10.vue";
import Box11 from "./Box11.vue";
import Box12 from "./Box12.vue";
import Box13 from "./Box13.vue";
import Box14 from "./Box14.vue";
import Box15 from "./Box15.vue";
import Box16 from "./Box16.vue";


import pageRightFloat from "../common/pageRightFloat.vue";
import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";

export default {
  components: {
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    Box6new,
    Box7,
    Box8,
    Box9,
     Box9new,
    Box10,
    Box11,
    Box12,
    Box13,
    Box14,
    Box15,
    Box16,
    pageRightFloat,
    Header,
    Footer,

  },
  data() {
    return {from:""};
  },
  mounted() {
   this.from=this.getQueryString("from")
  },
  methods: {
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
    zixun(name) {
      zhuge.track("H5_人工智能专题页", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
 .architectPage{
 width: 750px;
 position: relative;
 }
</style>
